import { TableBody, TableCell, TableRow, Button } from "@windmill/react-ui";
import CommissionPaymentModal from "components/modal/CommissionPaymentModal";
import React, { useState } from "react";

const CommissionPaymentTable = ({
  tripadvancepayment,
  formulaKeys = [],
  perpage,
  currentPage,
  tab,
  hideEdit,
  setIsUpdate,
}) => {
  const paymentList = Array.isArray(tripadvancepayment)
    ? tripadvancepayment
    : [];
  const [isOpen, setIsOpen] = useState(false);
  const [payableAmount, setPayableAmount] = useState(0);
  const [vaId, setVaId] = useState();
  const handleOpenCommissionModal = () => {
    setIsOpen(true);
  };
  const handleCloseCommissionModal = () => {
    setIsOpen(false);
  };
  return (
    <TableBody>
      {paymentList.length > 0 ? (
        paymentList.slice(0, perpage).map((data, index) => (
          <TableRow key={data.va_id || index}>
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.ref_no || "-"}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.client_name || "-"}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.start_date || "-"}
              <br />
              {data.end_date || "-"}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.franchise_name || "-"}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.vendor_name || "-"}
            </TableCell>
            {formulaKeys.map((key) => {
              const isProfit = key === "profit";
              const isCommissionOwed = key === "commission_owed";
              const value = data[key];
              return (
                <TableCell key={key} className="text-sm text-center">
                  {isProfit ? (
                    <span
                      className={
                        Number(value) <= 0 ? "text-red-600" : "text-green-600"
                      }
                    >
                      ₹ {Number(value ?? 0).toFixed(2)}
                    </span>
                  ) : isCommissionOwed ? (
                    <>
                      ₹ {Number(value ?? 0).toFixed(2)}
                      {tab !== 2 && (
                        <div className="text-xs text-gray-500">
                          {data.commission_paid > 0 && (
                            <p className="text-sm text-green-500 mb-1 mt-1">
                              Paid: ₹
                              {Number(data.commission_paid ?? 0).toFixed(2)}
                            </p>
                          )}
                          <p className="text-sm text-yellow-500 mb-1">
                            Pending: ₹
                            {Number(data.commission_pending ?? 0).toFixed(2)}
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    `₹ ${Number(value ?? 0).toFixed(2)}`
                  )}
                </TableCell>
              );
            })}

            <TableCell className="text-sm text-center">
              <span
                className={`font-semibold ${
                  data.payment_status === "Trip Not Went"
                    ? "text-gray-500"
                    : Number(data.profit) <= 0
                      ? "text-red-600"
                      : data.payment_status === "Bill Pending"
                        ? "text-gray-500"
                        : data.payment_status === "Paid"
                          ? "text-green-600"
                          : "text-red-600"
                }`}
              >
                {data.payment_status === "Trip Not Went"
                  ? "Trip Not Went"
                  : Number(data.profit) <= 0
                    ? "Loss"
                    : data.payment_status}
              </span>
            </TableCell>
            {tab !== 2 && (
              <TableCell className="text-sm text-center">
                {hideEdit && (tab === 3 || tab === 1) ? (
                  Number(data.profit) > 0 &&
                  ["Unpaid", "Partially Paid"].includes(data.payment_status) ? (
                    <Button
                      size="small"
                      onClick={() => {
                        handleOpenCommissionModal();
                        setPayableAmount(data?.commission_pending);
                        setVaId(data?.va_id);
                      }}
                    >
                      Pay
                    </Button>
                  ) : (
                    <span>-</span>
                  )
                ) : (
                  <span>-</span>
                )}
              </TableCell>
            )}
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={15} className="text-sm text-center">
            No Data Available
          </TableCell>
        </TableRow>
      )}
      <CommissionPaymentModal
        isOpen={isOpen}
        onClose={handleCloseCommissionModal}
        requestAmount={payableAmount}
        id={vaId}
        setIsUpdate={setIsUpdate}
      />
    </TableBody>
  );
};

export default CommissionPaymentTable;
